export default __webpack_public_path__ + "static/media/inactive3.b6952748.svg";